module.exports = new __parcel__URL__("TrelloSelectBoardJswIllustartion.3e37bc88.svg").toString();